export function vector (x = 0, y = 0) {
  return { x, y }
}

export function multiply (a, b) {
  a.x *= typeof b === 'number' ? b : b.x
  a.y *= typeof b === 'number' ? b : b.y
  return a
}

export function subtract (a, b) {
  a.x -= typeof b === 'number' ? b : b.x
  a.y -= typeof b === 'number' ? b : b.y
  return a
}

export function toTilePos (v, tileSize) {
  return [
    Math.floor(v.x / tileSize),
    Math.floor(v.y / tileSize)
  ]
}

export function fromTilePos (x, y, tileSize) {
  return vector(
    x * tileSize,
    y * tileSize
  )
}

export function fromIndex (i, rowLength) {
  return vector(
    i % rowLength,
    Math.floor(i / rowLength)
  )
}

export function distance (a, b) {
  const x = a.x - b.x
  const y = a.y - b.y

  return Math.sqrt(x * x + y * y)
}

export function distance2 (x0, y0, x1, y1) {
  const x = x0 - x1
  const y = y0 - y1

  return Math.sqrt(x * x + y * y)
}

export function angle (a, b) {
  return Math.atan2(b.y - a.y, b.x - a.x)
}

export function angle2 (x0, y0, x1, y1) {
  return Math.atan2(y1 - y0, x1 - x0)
}
